import { ApiErrorResponse } from './isApiError'
import { HandledError } from '../types'

export const handleKnownErrors = (
	error: ApiErrorResponse,
): HandledError | undefined => {
	console.log('error', error)
	if ('error' in error) {
		switch (error.error) {
		case 'TypeError: Network request failed':
			return { snackbar: 'Відсутній зв\'язок з інтернетом' }
		default:
			return undefined
		}
	} else if ('detail' in error.data) {
		switch (error.data.detail) {
		case 'No active account found with the given credentials':
			return { message: 'Невірне ім\'я користувача або пароль' }
		default:
			return undefined
		}
	}
}
